import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const useGetRecords = (sort, size) => {
  return useQuery({
    queryKey: ["name", sort],
    queryFn: async () => {
      const url = `/api/records?q=&page=1&size=${size}&sort=${sort.toLowerCase()}`;
      const res = await axios.get(url, {
        validateStatus: (status) => status < 500,
      });

      if (res.status === 404) {
        return [];
      }

      if (res.status !== 200) {
        return [];
      }
      const data = res.data;
      if (!data || !data.hits || !data.hits.hits) {
        return [];
      }
      const records = data.hits.hits;
      return records;
    },
    refetchOnMount: true,
    enabled: true,
  });
};

export const useGetRecord = () => {
  return useQuery({
    queryKey: ["record"],
    queryFn: async () => {
      const url = `/api/records?q=&page=1&size=1`;
      const res = await axios.get(url, {
        validateStatus: (status) => status < 500,
      });

      if (res.status === 404) {
        return [];
      }

      if (res.status !== 200) {
        return [];
      }
      return res.data;
    },
    refetchOnMount: true,
    enabled: true,
  });
};

export const useGetNumberOfDeimsSites = () => {
  return useQuery({
    queryKey: ["deimsSitesNumber"],
    queryFn: async () => {
      const url = `https://deims.org/api/sites`;
      const res = await axios.get(url, {
        validateStatus: (status) => status < 500,
      });
      if (res.status === 404) {
        return `Error 404`;
      }
      if (res.status !== 200) {
        return "Error fetching DEIMS sites number";
      }
      const data = res.data;
      return data.length;
    },
    refetchOnMount: true,
    enabled: true,
  });
};
